<template>
    
    <!-- pc -->
    <div id="header-nav">
        <div class="header-nav-wrap max-width">
            <router-link to="/" class="pointer">
                <img class="logo" src="@/assets/logo.png">
            </router-link>
            <div class="nav-right">
                <router-link :to="item.url" v-for="(item,index) in navList" :key="index"  class="pointer" activeClass="on">{{ item.name }}</router-link>
            </div>
        </div>
    </div>

    <!-- mobile -->
    <div id="header-nav-m">
        <div class="header-nav-m-wrap flex-alignc-justifyb">
            <img class="left-img" src="@/assets/logo-m.png" @click="isNav=false,router.push({ path: '/' })">
            <img class="right-img" src="@/assets/icon.png" @click="isNav=!isNav">
        </div>
        <div v-show="isNav" class="nav-list-m">
            <div class="nav-list-box">
                <router-link :to="item.url" v-for="(item,index) in navList" :key="index" class="pointer" activeClass="on" @click.native="routerClick">{{ item.name }}</router-link>
            </div>
        </div>
    </div>
    
</template>

<script setup>
    import { reactive,ref } from 'vue'
    let isNav = ref(false)
    let navList = reactive([
        { name:'首页', url:'/index' },
        { name:'产品介绍', url:'/introduce' },
        { name:'关于我们', url:'/about' }
        // { name:'招商加盟', url:'/join' }
    ])

    function routerClick() {
        isNav.value = false
    }
</script>

<style lang="scss">

#header-nav {
    width: 100%; 
    height: 70Px; 
    position: fixed;
    top: 0;
    left: 0;
    background: #FFFFFF;
    .header-nav-wrap {
        margin: 0 auto;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0;
        background: #FFFFFF;
        .logo {
            // width: 100px;
            height: 40Px;
        }
        .nav-right {
            display: flex;
            align-items: center;
            .pointer {
                width: 100Px;
                height: 40Px;
                line-height: 40Px;
                text-align: center;
                border-radius: 20Px;
                font-size: 14Px;
                color: #333;
                margin-left: 10px;
                padding: 0 20Px;
                &.on {
                    font-weight: bold;
                    background: linear-gradient(180deg, #FFDF6D 0%, #FFC225 100%);
                }
            }
        }
    }
}

#header-nav-m {
    width: 100%;
    height: 50Px;
    position: fixed;
    top: 0;
    left: 0;
    display: none;
    background: #FFFFFF;
    padding: 0 15Px;
    .header-nav-m-wrap {
        width: 100%;
        height: 100%;
    }
    .left-img {
        // width: 74px;
        height: 30px;
    }
    .right-img {
        width: 24px;
        height: 24px;
    }
    .nav-list-m {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        background: #FFFFFF;
        padding: 10px;
        .nav-list-box {
            // background: #FAFAFA;
            // box-shadow: 0 2Px 6Px 0 rgba(0,0,0,0.05);
            display: flex;
            flex-direction: column;
            font-size: 15px;
            padding: 10px;
            .pointer {
                padding: 10px 0;
                margin-bottom: 10px;
                border-bottom: 1px solid #EEE;
                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }
}

</style>